import Offer from './styled';

export default Offer;
